"use client";

import { ServiceAddon } from "../services/order-types";

interface AddonsGridProps {
  addons: ServiceAddon[];
  loadingAddons: boolean;
  setOrderAddons: React.Dispatch<React.SetStateAction<any[]>>;
  disabled?: boolean;
}

export default function AddonsGrid({
  addons,
  loadingAddons,
  setOrderAddons,
  disabled = false, 
}: AddonsGridProps) {
  const handleAdd = (addon: ServiceAddon) => {
    if (disabled) return; // 
    setOrderAddons((prev) => {
      const exists = prev.find(
        (it) => it.id === addon.id && it.type === "addon"
      );
      if (exists) {
        return prev.map((it) =>
          it.id === addon.id && it.type === "addon"
            ? { ...it, qty: it.qty + 1 }
            : it
        );
      }
      return [
        ...prev,
        {
          id: addon.id,
          serviceTypeName: "Dịch vụ thêm",
          serviceName: addon.name,
          qty: 1,
          price: Number(addon.price),
          type: "addon",
        },
      ];
    });
  };

  return (
    <div className="mt-8 bg-white p-4 rounded-xl shadow-sm border-2 border-gray-300">
      <h3 className="font-semibold text-gray-700 mb-4 text-lg">Dịch vụ thêm</h3>

      {loadingAddons ? (
        <div className="text-center text-gray-400 py-6">
          Đang tải dịch vụ thêm...
        </div>
      ) : addons.length === 0 ? (
        <div className="text-center text-gray-500 py-6">
          Không có dịch vụ thêm nào
        </div>
      ) : (
        <>
          {disabled && (
            <div className="text-center text-amber-600 font-medium mb-4">
              ⚠️ Vui lòng chọn dịch vụ giặt ủi trước khi thêm dịch vụ thêm
            </div>
          )}

          <div className={`grid grid-cols-4 gap-4 ${disabled ? "opacity-60" : ""}`}>
            {addons.map((addon) => (
              <div
                key={addon.id}
                onClick={() => handleAdd(addon)}
                className={`p-4 border rounded-xl shadow-sm flex flex-col items-center justify-between transition ${
                  disabled
                    ? "bg-gray-100 cursor-not-allowed"
                    : "bg-green-50 hover:bg-green-100 cursor-pointer"
                }`}
              >
                <div className="w-10 h-10 mb-2 flex items-center justify-center bg-green-200 rounded-full text-lg">
                  🧩
                </div>

                <div className="text-center font-medium text-gray-800 mb-1">
                  {addon.name}
                </div>

                <div className="text-gray-600 text-sm mb-2">
                  {Number(addon.price).toLocaleString("vi-VN")}₫
                </div>

                <button
                  disabled={disabled}
                  className={`px-3 py-1 text-white text-xs rounded ${
                    disabled
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-blue-500 hover:bg-blue-600"
                  }`}
                >
                  + Thêm
                </button>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
